/**
 * APP.JS
 */

// tarteaucitron.userInterface.openPanel();
// // Call popin of front settings
// $("a.handleRgpdCookie").removeClass('active').on("click", function (e) {
//   e.preventDefault();
//   tarteaucitron.userInterface.openPanel();
// });
//
// tarteaucitron.user.analyticsUa = 'UA-';
// //
// // if (settings.analyticsMore.length > 0) {
// //   tarteaucitron.user.analyticsMore = function () {
// //     settings.analyticsMore;
// //   };
// // }
//
// (tarteaucitron.job = tarteaucitron.job || []).push('analytics');

/**
 * Header fixed avec hauteur dynamique.
 * Classes sur le body
 */
var headroom = new Headroom(document.body, {
	offset: 84,
	tolerance: 16,
});
headroom.init();

/**
 * Toggle du menu
 */
var toggleNav = document.querySelectorAll(".toggle-nav");
toggleNav.forEach((item) => {
	item.addEventListener("click", function () {
		document.body.classList.toggle("nav-is-open");
	});
});

/**
 * Slider du Hero de l'accueil
 */
var homeHero = document.querySelector(".hero-carousel");
if (homeHero) {
	var heroCarousel = new Flickity(homeHero, {
		fade: true,
		wrapAround: true,
		pageDots: false,
		prevNextButtons: false,
		autoPlay: true,
	});
	// recréation des dots:
	document.querySelectorAll(".carousel-dots button").forEach((item) => {
		item.addEventListener("click", (event) => {
			heroCarousel.select(item.dataset.index, true);
		});
	});
}

/**
 * Slider des Logos de l'accueil
 */
var homeLogo = document.querySelector(".logo-carousel");

if (homeLogo) {
	var logoCarousel = new Flickity(homeLogo, {
		wrapAround: true,
		pageDots: false,
		prevNextButtons: false,
		autoPlay: true,
		groupCells: true,
		freeScroll: true,
	});
}
/*
	formulaire de contact
 */

$("form#contact").on("submit", function () {
	let dataObj = {};
	let fields = $(this).find("select, textarea, input").serializeArray();

	$(fields).each(function (i, field) {
		dataObj[field.name] = field.value;
	});

	if ($('div.checkbox-group').length > 0 && $('div.checkbox-group.required :checkbox:checked').length == 0) {
		var alertBox = '<div class="alert alert-danger" role="alert">Le champ Type d\'activité est obligatoire.</div>';
		$('.messages').html(alertBox);
		$('div.checkbox-group').css({
			"color": "red",
			"border": "1px solid red"
		}).addClass('error');

		// Si le groupe de checkbox activité n'a pas été coché
		$('div.checkbox-group.error input').click(function () {
			$('div.checkbox-group').attr('style', '').removeClass('error');
		});

	}
	else {

		$.ajax({
			url: "/contact/send",
			method: "POST",
			dataType: 'json',
			data: fields,
			headers: {
				"X-CSRF-TOKEN": dataObj._token
			},
			success: function (response) {
				var err = false;

				if (response.success == 0) {
					err = true;

					var messageText = response.msg
					var type = "danger";
				}
				else {
					var messageText = "Votre message a bien été envoyé."
					var type = "success";
				}

				var alertBox = '<div class="alert alert-' + type + '" role="alert">' + messageText + '</div>';
				if (messageText) {
					$('.messages').html(alertBox);

					// On efface pas les champs si il y a une erreur.
					if(err == false) {
						$(':input', 'form#contact')
							.not(':button, :submit, :reset, :hidden')
							.val('')
							.prop('checked', false)
							.prop('selected', false);
					}
				}

				// form-message
				$('body, html').animate({
					scrollTop: $('#form-message').offset().top - 200
				}, 100);

			},
		});
	}

	return false;
});

/*
	newsletter
 */

$("form#form-newsletter").on("submit", function () {
	let dataObj = {};
	let fields = $(this).find("select, textarea, input").serializeArray();


	$.ajax({
		url: "/newsletter/subscribe",
		method: "POST",
		dataType: 'json',
		data: fields,
		headers: {
			"X-CSRF-TOKEN": dataObj._token
		},
		success: function (response) {
			if (response.success == 0) {

				var valid = '<div class="msgValid invalid-feedback" style="display:block">Erreur d\'inscription à la newsletter</div>';
				$('.email-newsletter').addClass('is-invalid');
			}
			else {
				if(response.deja_enregistre == 1) {
					var textValid = 'Vous êtes déjà inscrit à la newsletter'
				} else {
					var textValid = 'Votre adresse email a bien été enregistré';
				}

				var valid = '<div class="msgValid valid-feedback" style="display:block">'+textValid+'</div>';
				$('.email-newsletter').addClass('is-valid');

				$(':input', 'form#form-newsletter')
					.not(':button, :submit, :reset, :hidden')
					.val('')
					.prop('checked', false)
					.prop('selected', false);
			}

			$("form#form-newsletter .field-email-group").after(valid);

			setTimeout(function () {
				$('.email-newsletter').removeClass('is-valid').removeClass('is-invalid');
				$('.msgValid').empty();
			}, 4000);

		},
	});


	return false;
});